// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"pr-z","giftOrPromoSelector":"qr-z","disabled":"rr-z","subTitle":"sr-z","selectShipAddressMessage":"tr-z","changePayment":"ur-z"};